angular.module('core')
  .factory('DblActivity', ['assignedFocusApi', function(assignedFocusApi) {
        var EVENT_CODES = {
            LESSON_COMPLETED: 110,
            LESSON_PAUSED: 120,
            LESSON_GROUP_COMPLETED: 130,
            LESSON_GROUP_STRUGGLING: 600,
            STANDARD_COMPLETED: 701,
            LESSON_STRUGGLING: 702,
            LESSON_GROUP_IN_PROGRESS: 900,  // currently a synthetic JavaScript activity
            DBL_LESSON_GROUP_COMPLETED: 703
        };

        var LESSON_ACTIVITES = [
            EVENT_CODES.LESSON_COMPLETED,
            EVENT_CODES.LESSON_PAUSED,
            EVENT_CODES.LESSON_STRUGGLING
        ];

        var LESSON_GROUP_ACTIVITES = [
            EVENT_CODES.LESSON_GROUP_COMPLETED,
            EVENT_CODES.LESSON_GROUP_STRUGGLING,
            EVENT_CODES.LESSON_GROUP_IN_PROGRESS,
            EVENT_CODES.DBL_LESSON_GROUP_COMPLETED
        ];

        function Activity (activityRecord) {
            this.assignmentId = activityRecord.assignment_id;
            this.dblStandard = activityRecord.dbl_standard;
            this.demoLessonName = activityRecord.demo_lesson_name;
            this.eventCode = activityRecord.event_code;
            this.eventCodeName = activityRecord.event_code_name;
            this.firstName = activityRecord.first_name;
            this.id = activityRecord.id;
            this.lastName = activityRecord.last_name;
            this.lessonCompletedInstanceCount = activityRecord.lesson_completed_instance_count;
            this.lessonFailedCount = activityRecord.lesson_failed_count;
            this.lessonsInGroupCount = activityRecord.lessons_in_group_count;
            this.lessonGoalId = activityRecord.lesson_goal_id;
            this.lessonPassed = activityRecord.lesson_passed;
            this.lessonSlotId = activityRecord.lesson_slot_id;
            this.lessonSlotName = activityRecord.lesson_slot_name;
            this.localizedLessonName = activityRecord.localized_lesson_name;
            this.milestoneTriggerLessonSlotId = activityRecord.milestone_trigger_lesson_slot_id;
            this.needsAttention = activityRecord.needs_attention;
            this.standards = activityRecord.standards;
            this.strugglingGroupFailedLessonsCount = activityRecord.struggling_group_failed_lessons_count;
            this.strugglingGroupTestedLessonsCount = activityRecord.struggling_group_tested_lessons_count;
            this.studentId = activityRecord.student_id;
            this.timestamp = activityRecord.timestamp;

            if (_.isNumber(activityRecord.total_lesson_time)) {
                // IN-522 If Duration <= 1, it should always display "1 min" (it's in milliseconds)
                this.totalLessonTime = Math.max(activityRecord.total_lesson_time, 60000);
            }

            this.uid = activityRecord.uid;

            this.isAssignmentLong = function () {
                return assignedFocusApi.isLongTermAssignment(activityRecord);
            };

            this.isLessonActivity = function () {
                return _.contains(LESSON_ACTIVITES, this.eventCode);
            };

            this.isLessonCompleteActivity = function () {
                return this.eventCode === EVENT_CODES.LESSON_COMPLETED;
            };

            this.isStandardCompleteActivity = function () {
                return this.eventCode === EVENT_CODES.STANDARD_COMPLETED;
            };

            this.isLessonPausedActivity = function () {
                return this.eventCode === EVENT_CODES.LESSON_PAUSED;
            };

            this.isLessonGroupInProgressActivity = function () {
                return this.eventCode === EVENT_CODES.LESSON_GROUP_IN_PROGRESS;
            };

            this.isLessonGroupStrugglingActivity = function () {
                return this.eventCode === EVENT_CODES.LESSON_GROUP_STRUGGLING;
            };

            this.isLessonGroupCompletedActivity = function () {
                return (this.eventCode === EVENT_CODES.LESSON_GROUP_COMPLETED || this.eventCode === EVENT_CODES.DBL_LESSON_GROUP_COMPLETED);
            };

            this.isLessonGroupActivity = function () {
                return _.contains(LESSON_GROUP_ACTIVITES, this.eventCode);
            };

            this.isLessonStrugglingActivity = function () {
                return this.eventCode === EVENT_CODES.LESSON_STRUGGLING;
            };
        }

        Activity.EVENT_CODES = EVENT_CODES;

        return Activity;
    }]);
